import { reqAPI } from "../utils/fetch-request";

export async function getBalance(){
  return reqAPI('api/merchant/balance');
}

export async function historyBalance(params = {}){
  return reqAPI('api/merchant/history-balances', params);
}

export async function exportBalanceHistory(params = {}) {
  return reqAPI('api/merchant/history-balances/export', params, 'GET', false, 'blob');
}

// appType: 'API' | 'DASHBOARD' (which balance the VA tops up)
export async function getListVA(appType = 'API'){
  return reqAPI('api/merchant/list-va', { app_type: appType });
}

// from: 'dashboard' | 'api' (source balance); amount in IDR
export async function transferBalance(from, amount){
  return reqAPI('api/merchant/transfer-balance', { from, amount }, 'POST');
}

export async function generateDashboardVA(){
  return reqAPI('api/merchant/generate-dashboard-va', {}, 'POST');
}